import SelectOrderMethodModal from "components/SelectOrderMethodModal";

const SharedModalRenderer = ({ modalType, onClose }: { modalType: string | null; onClose: () => void }) => {
  if (modalType === "OrderMethodModal")
    return <SelectOrderMethodModal isVisible={modalType != null} onClose={onClose} />;
  return null;
};

export default SharedModalRenderer;
